'use client';
import { Skeleton } from "@heroui/react";

export default function Loading() {
  return (
    <div className="flex flex-col gap-4 flex-wrap md:grid md:grid-cols-4">
      {Array.from({ length: 12 }).map((_, index) => (
        <Skeleton key={String(index)} className="min-w-[150px] min-h-[200px]" />
      ))}
    </div>
  );
}
